import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useDropzone } from "react-dropzone";
import { useTheme } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { postFormData } from "../shared/http/httpService";

const PersistenceImportModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();

  const [file, setFile] = useState(null);
  const [upsert, setUpsert] = useState(true);
  const client = useSelector((state) => state.client.name);

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0]);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleImport = async (event) => {
    event.preventDefault();
    if (!file) {
      enqueueSnackbar(t("persistenceImportModal:selectFileWarning"), {
        variant: "warning",
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file, file.name);
      formData.append("upsert", upsert);
      formData.append("client", client);

      await postFormData("/persistence/import", formData);
      enqueueSnackbar(t("persistenceImportModal:successImport"), {
        variant: "success",
      });
      handleClose();
    } catch (error) {
      enqueueSnackbar(t("persistenceImportModal:errorImport"), {
        variant: "error",
      });
      handleClose();
    }
  };

  const handleClose = () => {
    setFile(null);
    setUpsert(true);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("persistenceImportModal:title")}</DialogTitle>

      <DialogContent>
        <div
          {...getRootProps()}
          style={{
            padding: "20px",
            border: `2px dashed ${theme.palette.divider}`,
            borderRadius: "8px",
            marginBottom: "20px",
            textAlign: "center",
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            cursor: "pointer",
          }}>
          <input
            {...getInputProps()}
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {file ? file.name : t("persistenceImportModal:dragAndDropOrClick")}
        </div>

        <RadioGroup
          value={upsert ? "upsert" : "delete"}
          onChange={(e) => setUpsert(e.target.value === "upsert")}>
          <FormControlLabel
            value="upsert"
            control={<Radio color="primary" />}
            label={t("persistenceImportModal:optionUpsert")}
          />
          <FormControlLabel
            value="delete"
            control={<Radio color="secondary" />}
            label={t("persistenceImportModal:optionDelete")}
          />
        </RadioGroup>
      </DialogContent>

      <DialogActions>
        <Button id="cancelar " onClick={handleClose}>
          {t("persistenceImportModal:cancel")}
        </Button>
        <Button
          id="import"
          variant="contained"
          color="primary"
          onClick={handleImport}
          disabled={!file}>
          {t("persistenceImportModal:import")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersistenceImportModal;
